import { useRef, useState } from 'react';
import { t } from '@lingui/macro';

import Plus from '@decisiv/iconix/lib/components/Plus';
import Upload from '@decisiv/iconix/lib/components/Upload';

import Button from '@decisiv/ui-components/lib/components/Button';
import Flex from '@decisiv/ui-components/lib/components/Flex';
import Menu from '@decisiv/ui-components/lib/components/Menu';
import Popover from '@decisiv/ui-components/lib/components/Popover';

interface AddAssetMenuProps {
  disabled?: boolean;
  kind?: 'primary' | 'secondary';
  /**
   * Each menu item is rendered but disabled when its handler is omitted, so the
   * entry point still communicates intent where a flow doesn't apply (e.g. the
   * manual single-asset add has no target on the Accounts index).
   */
  onSelectManual?: () => void;
  onSelectBulk?: () => void;
}

export default function AddAssetMenu({
  disabled,
  kind = 'secondary',
  onSelectManual,
  onSelectBulk,
}: AddAssetMenuProps) {
  const buttonRef = useRef<HTMLButtonElement>(null);
  const [visible, setVisible] = useState(false);

  const hide = () => {
    setVisible(false);
  };

  const items = [
    {
      id: 'manual',
      text: t`Add Asset`,
      icon: Plus,
      disabled: !onSelectManual,
      onSelect: () => {
        hide();
        onSelectManual?.();
      },
    },
    {
      id: 'bulk',
      text: t`Bulk Add Assets`,
      icon: Upload,
      disabled: !onSelectBulk,
      onSelect: () => {
        hide();
        onSelectBulk?.();
      },
    },
  ];

  return (
    <>
      <Button
        text={t`Add Asset`}
        size="small"
        kind={kind}
        disabled={disabled}
        onClick={() => setVisible((prev) => !prev)}
        ref={buttonRef}
      />
      <Popover
        placement="bottom-start"
        target={buttonRef}
        manageEvents={false}
        zIndex={200}
        visible={visible}
        onRequestHide={hide}
      >
        <Flex flexDirection="column">
          <Menu items={items} />
        </Flex>
      </Popover>
    </>
  );
}
